<div class="col px-lg-5 px-2">
	
	<app-nav-gestion-donnees
		class="row py-5"
		[addable]="isAddable"
		(addEvent)="openModalAjout()"
		[isImportable]="isImportable"
		(importingEvent)="uploader.click()"
		[isExportable]="isExportable"
		(exportingEvent)="exportPrescripteurs()"
	></app-nav-gestion-donnees>

	<input hidden type="file" #uploader (change)="importPrescripteurs($event)" />

	<div class="row my-3">
		<div class="row my-4">
			<pagination-controls
				class="d-flex justify-content-center"
				(pageChange)="currentPage = $event"
				previousLabel="Précédent"
				nextLabel="Suivant"
			>
			</pagination-controls>
			<div class="d-flex justify-content-center">
				<label class="form-label mt-2 mx-2">Elements par page</label>
				<div class="">
					<select
						[(ngModel)]="itemsPerPage"
						#ctrl="ngModel"
						(change)="currentPage = 1"
						[ngModelOptions]="{ standalone: true }"
						class="form-select"
					>
						<option [value]="5">5</option>
						<option *ngIf="prescripteurs?.length >= 5" [value]="10">10</option>
						<option *ngIf="prescripteurs?.length >= 10" [value]="25">25</option>
						<option *ngIf="prescripteurs?.length >= 25" [value]="50">50</option>
						<option *ngIf="prescripteurs?.length >= 50" [value]="100">100</option>
					</select>
				</div>
			</div>
		</div>

		<div class="row my-2">
			<div class="col-2 ms-lg-auto">
			</div>

			<div class="col-lg-3 col-12 ps-lg-5">
				<div class="input-group">
					<span class="input-group-text bg-transparent"
						><i class="bi bi-search" aria-hidden="true"></i
					></span>
					<input
						type="text"
						class="form-control border-start-0"
						placeholder="Nom de la structure, type de structure"
						[(ngModel)]="searchedText"
					/>
				</div>
			</div>
		</div>

		<div *ngIf="!isMobile" class="row mt-3">
			<div class="col-2">
				<span class="hand-cursor fw-bold limitLineSpan" (click)="sortChange('lastName')"
					>Nom de la structure
				</span>
			</div>
			<div class="col-2">
				<span class="ps-1 hand-cursor fw-bold limitLineSpan">
					Type de structure
				</span>
			</div>
			<div class="col-2">
				<span
					class="ps-1 hand-cursor fw-bold limitLineSpan"
					(click)="sortChange('address.label')"
					>Adresse
				</span>
			</div>
			<div class="col-5">
				<span class="ps-1 hand-cursor fw-bold limitLineSpan">
					Contacts
				</span>
			</div>
			<div class="col-1"></div>
		</div>

		<div class="mt-4" *ngIf="isListingLoading">
			<app-loading></app-loading>
		</div>

		<div *ngIf="!isListingLoading" class="mt-4">
			<div
				*ngFor="
					let prescripteur of prescripteurs
						| filterPrescripteurByName: searchedText
						| orderBy : sortType : sortOrder
						| paginate
							: {
									itemsPerPage: itemsPerPage,
									currentPage: currentPage
							  }
				"
				class="row my-1 pt-3 pb-1 rounded rounded-3 bg-light"
			>
				<span class="col-lg-2 col-12">
					<span *ngIf="isMobile" class="fw-bold limitLineSpan">Nom de la structure:</span>
					{{ prescripteur?.nomStructure }}
				</span>
				<div class="col-lg-2">
					<div class="d-flex">
						<span class="flex-grow-1 limitLineSpan">
							<span *ngIf="isMobile" class="fw-bold limitLineSpan">Type de strucuture :</span>
							{{ prescripteur?.typeStructure?.name }}
						</span>
					</div>
				</div>
				<div class="col-lg-2">
					<div class="d-flex">
						<span class="flex-grow-1 limitLineSpan">
							<span *ngIf="isMobile" class="fw-bold limitLineSpan">Adresse :</span>
							{{ prescripteur?.addressStructure?.label }}
						</span>
					</div>
				</div>
				<div class="col-lg-5 d-flex p-lg-0">
					<div class="flex-grow-1">
						<span *ngIf="isMobile" class="fw-bold limitLineSpan"> Contacts : </span>
						<span
							*ngFor="let exp of prescripteur.contacts |  orderBy:'lastName'"
							class="me-1 limitLineSpan"
						>
							{{ exp && ' ' + exp.lastName + ' ' +exp.firstName + '  |  ' + exp.fonction + '  |  ' + exp.email }}<br/>
						</span>

					</div>
				</div>
				<div class="col-12 col-lg-1 d-flex p-lg-0">
					<i
						[routerLink]="['/gestion/prescripteurs', prescripteur.id]"
						profile="button"
						class="fs-4 bi bi-caret-right-fill mb-1 me-2"
						aria-hidden="true"
					></i>
				</div>
			
			</div>
		</div>
		<div class="row my-4">
			<pagination-controls
				class="d-flex justify-content-center"
				(pageChange)="currentPage = $event"
				previousLabel="Précédent"
				nextLabel="Suivant"
			>
			</pagination-controls>
			<div class="d-flex justify-content-center">
				<label class="form-label mt-2 mx-2">Elements par page</label>
				<div class="">
					<select
						[(ngModel)]="itemsPerPage"
						#ctrl="ngModel"
						(change)="currentPage = 1"
						[ngModelOptions]="{ standalone: true }"
						class="form-select"
					>
						<option [value]="5">5</option>
						<option *ngIf="prescripteurs?.length >= 5" [value]="10">10</option>
						<option *ngIf="prescripteurs?.length >= 10" [value]="25">25</option>
						<option *ngIf="prescripteurs?.length >= 25" [value]="50">50</option>
						<option *ngIf="prescripteurs?.length >= 50" [value]="100">100</option>
					</select>
				</div>
			</div>
		</div>
	</div>
</div>
